import { isEmpty, isEqual, isString } from 'lodash';
import { EditableField, Field } from './Field';

export class TagField implements EditableField {
  readonly fieldType = 'TagField';
  readonly tagIds: string[];
  readonly componentId: string;
  readonly tagOptions: MBAPI.WorkflowTemplate_components_TagComponent_options[];
  readonly multiselect: boolean;
  readonly addAdditionalValues: boolean;

  constructor(
    tagIds: string[],
    componentId: string,
    tagOptions: MBAPI.WorkflowTemplate_components_TagComponent_options[],
    multiselect: boolean,
    addAdditionalValues: boolean,
  ) {
    this.tagIds = tagIds;
    this.componentId = componentId;
    this.tagOptions = tagOptions;
    this.multiselect = multiselect;
    this.addAdditionalValues = addAdditionalValues;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return (
      field instanceof TagField &&
      this.componentId === field.componentId &&
      isEqual(this.tagIds, field.tagIds)
    );
  }

  toFieldJson() {
    return this.tagIds;
  }

  get isEmpty() {
    return isEmpty(this.tagIds);
  }

  static fromFieldJson(
    jsonBlob: MBAPI.Scalar.JSON,
    componentId: string,
    tagOptions: MBAPI.WorkflowTemplate_components_TagComponent_options[],
    multiselect: boolean,
    addAdditionalValues: boolean,
  ) {
    if (Array.isArray(jsonBlob) && jsonBlob.every(isString)) {
      return new TagField(jsonBlob, componentId, tagOptions, multiselect, addAdditionalValues);
    } else {
      return null;
    }
  }
}
